<template>

  <p v-bind:style="[bannerPlaceHolderWithWalleteWeb.styles]" class="offer-message p-2" 
            v-if="bannerPlaceHolderWithWalleteWeb && Object.keys(bannerPlaceHolderWithWalleteWeb).length">
            {{bannerPlaceHolderWithWalleteWeb.text}}
  </p>
</template>

<script>
  import {mapGetters} from 'vuex'

  export default {
    props: ['walletDisName', 'isOutageApplicable'],
    data: function () {
      return {
      }
    },
    computed: {
      ...mapGetters(['bannerPlcaeHolderData']),
      bannerPlaceHolderFoPayMethodDown () {
        return this.bannerPlcaeHolderData && this.bannerPlcaeHolderData.length && this.bannerPlcaeHolderData.find(bannerData =>
          bannerData.placeholder_for.toLowerCase() === 'Others'.toLowerCase() && bannerData.status === true && bannerData.product_type.toLowerCase() === 'PAYMETHOD_OUTAGE_DOWN'.toLowerCase())
      },
      // banner when Wallet_WEB is added
      bannerPlaceHolderWithWalleteWeb: function () {
        const walletTagName = 'WEB_WALLET_SUBTEXT_' + this.walletDisName.replace(' ', '_')
        if (this.bannerPlcaeHolderData && this.bannerPlcaeHolderData.length) {
          let bannerObj = this.bannerPlcaeHolderData.find(bannerData =>
            bannerData.placeholder_for.toLowerCase() === 'Others'.toLowerCase() &&
              bannerData.status === true &&
              bannerData.product_type.toLowerCase() === walletTagName.toLowerCase())
          if (bannerObj && Object.keys(bannerObj).length) {
            let bannerPhObj = {}
            bannerPhObj.styles = {
              backgroundColor: this.isOutageApplicable && this.isOutageApplicable === 'DOWN' ? this.bannerPlaceHolderFoPayMethodDown && this.bannerPlaceHolderFoPayMethodDown.banner_color : bannerObj.banner_color,
              color: bannerObj.banner_text_color
            }
            bannerPhObj.text = bannerObj.tag_text
            bannerPhObj.status = bannerObj.status
            return bannerPhObj
          }
        }
      }
    }
  }
</script>

<style scoped>
.offer-message {
    padding: 5px 0;
    margin: 0;
    list-style: none;
    white-space: normal;
    margin-top: 7px;
    width: 100%;
    text-align: left;
  }


</style>



// WEBPACK FOOTER //
// walletMessage.vue?55715396